import { render, staticRenderFns } from "./CenterRoute.vue?vue&type=template&id=1de74b92&scoped=true"
import script from "./CenterRoute.vue?vue&type=script&lang=js"
export * from "./CenterRoute.vue?vue&type=script&lang=js"
import style0 from "./CenterRoute.vue?vue&type=style&index=0&id=1de74b92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de74b92",
  null
  
)

export default component.exports